import { Stack } from '@mui/system'
import { ResponsiveSideContent } from 'components-shared'
import { useTranslation } from 'react-i18next'
import COLUMNS_CONFIG from './config-columns-card'
import { useMemo } from 'react'
import { useTable } from 'packages/ui/Table'
import ScrollTable from 'components/global/CUK/ScrollTable'
import TableViewBase from 'packages/ui/Table/Table'
import useSort from '../use-sort'
import CardPreview from 'packages/ui/CardPreview'

const Body = ({ data }) => {
  const sortApi = useSort({ defaultOrderBy: 'name' })
  const columns = useMemo(() => {
    return COLUMNS_CONFIG
  }, [COLUMNS_CONFIG])
  const apiTable = useTable({
    items: data.sites ? sortApi.sort(data.sites) : [],
    columns,
  })

  return (
    <Stack
      sx={{
        overflow: 'hidden',
        overflowY: 'auto',
        flex: '1 1 auto',
        scrollbarWidth: 'none',
        height: '100%',
        border: 0,
        '&::-webkit-scrollbar ': {
          display: 'none',
        },
      }}
    >
      <ScrollTable ssid>
        <TableViewBase
          apiTable={apiTable}
          sort={{
            by: sortApi.orderBy,
            direction: sortApi.orderDirection,
            onChange: (name) => {
              const column = columns.find((column) => column.name === name)

              sortApi.orderByChange(column.sortBy || column.name)
            },
          }}
        />
      </ScrollTable>
    </Stack>
  )
}

const CardSites = ({ data, onClose }) => {
  const { t } = useTranslation()

  return (
    <ResponsiveSideContent onClose={onClose} style={{ padding: 0, marginTop: 0}}>
      <CardPreview title={t('ui_elements.card_title')} onClose={onClose} padding={'12px 12px 0 12px'}>
        <Body data={data} />
      </CardPreview>
    </ResponsiveSideContent>
  )
}

export default CardSites
